<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h3 class="form-heading">
      {{formConfig.pages[currentPage]?.pageHeader}}
    </h3>
  }

  @if (configSEPFlagObj && proxySEPForm) {
    <form
      [connect]="'payloadStates.' + configSEPFlagObj.formControlAttributes?.connectPath"
      [formGroup]="proxySEPForm"
      >
    </form>
  }

  <!-- Form Entries Loop -->
  @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
    <div class="form-row"
      [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
      <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [currentPage]="formConfig.pages[currentPage]"
      [formConfig]="formConfig"></ptl-entry-as-json>
    </div>
  }


<!-- Form Page Nav BUTTONS -->
<div class="form-buttons">

  @if (formConfig.form.formNavigation.saveButton.display) {
    <div class="save-later">
      <a href="#" (click)="saveForLaterButton($event)">
        <span class="text">SAVE FOR LATER</span>
        <span class="material-symbols-outlined save-icon">save</span>
      </a>
    </div>
  }

  <div class="navigational-controls">
      @if (formConfig.form.formNavigation.backButton.display && currentPage !== 0) {
        <div *ngIf="formConfig.form.formNavigation.backButton.display && currentPage !== 0" class="nav-link">
          <a href="{{ formConfig.form.formNavigation?.backButton?.redirect }}" (click)="backButtonClick($event)">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
      }

      @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
        <div class="nav-link spacer">
          <a href="{{ formConfig.form.formNavigation?.nextButton?.redirect }}" (click)="nextButtonClick($event)"
            [ngClass]="{'disable-link' : formConfig.form.formNavigation.nextButton.disable }">
            <span class="text">{{formConfig.form.formNavigation.nextButton.content ||"NEXT"}}</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>
      }

      @if (formConfig.form.formNavigation.submitButton.display && currentPage === formConfig.pages.length - 1) {
        <div class="nav-link spacer">
          <a href="#" (click)="submitButtonClick($event)"
            [ngClass]="{'disable-link' : formConfig.form.formNavigation.submitButton.disable }">
            <span class="text">{{ formConfig.form.formNavigation.submitButton.content || "VIEW PLANS" }}</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>
      }
    </div>

  </div>

</div>